import isPaymentsAllowed from '../../base/utils/is-payments-allowed';

export default defineNuxtRouteMiddleware(() => {
  if (!isPaymentsAllowed()) {
    return navigateTo('/');
  }
});
